var map = {
	"./osmTagToNameMapping-cs.template.ts": [
		11081,
		1081
	],
	"./osmTagToNameMapping-cs.ts": [
		61245,
		1245
	],
	"./osmTagToNameMapping-de.template.ts": [
		650,
		650
	],
	"./osmTagToNameMapping-de.ts": [
		38792,
		6411
	],
	"./osmTagToNameMapping-en.ts": [
		22548,
		2548
	],
	"./osmTagToNameMapping-hu.template.ts": [
		95886,
		5886
	],
	"./osmTagToNameMapping-hu.ts": [
		64732,
		4732
	],
	"./osmTagToNameMapping-it.template.ts": [
		55180,
		5180
	],
	"./osmTagToNameMapping-it.ts": [
		44618,
		4618
	],
	"./osmTagToNameMapping-pl.template.ts": [
		77655,
		7655
	],
	"./osmTagToNameMapping-pl.ts": [
		12747,
		2747
	],
	"./osmTagToNameMapping-sk.template.ts": [
		78449,
		8449
	],
	"./osmTagToNameMapping-sk.ts": [
		65893,
		5893
	],
	"./osmTagToNameMapping-xx.template.ts": [
		95043,
		5043
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 64712;
module.exports = webpackAsyncContext;